<template>
<a-row class="line">
    <a-form>
        <a-row>
            <a-form-item style="margin-bottom: 0px">
                <a-col :span="4"><span>类型：</span> </a-col>
                <a-col :span="20" style="text-align: left"> 
                    <a-select defaultValue="企业" @change="getKey" placeholder="类型" style="width: 160px">
                        <a-select-option v-for="(item, index) in types" :key="index" :value="item.value">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-col> 
            </a-form-item>
            <a-form-item style="margin-bottom: 0px">
                <a-col :span="4"> <span>标签：</span></a-col>
                <a-col :span="20">
                    <a-input 
                        v-if="this.pfxtag"
                        v-model='tags' 
                        :disabled="true" 
                        placeholder="请在此输入用户自定义的标签，标签之间用空格分隔" 
                    />
                    <a-input 
                        v-else
                        v-model='tags' 
                        :disabled="false"
                        placeholder="请在此输入用户自定义的标签，标签之间用空格分隔" 
                    />
                </a-col> 
            </a-form-item>
        </a-row> 
    </a-form>     
    <a-row> 
        <a-col :span="24" style="margin-top: 5px">
            <a-textarea 
                v-model="header"
                rows="1" 
                placeholder="在此输入标题行，各字段的标题用英文的逗号(,)分隔" 
                style="padding: 8px;" 
            />
            <a-textarea
                v-model="content" 
                rows="10" 
                placeholder="在此输入数据行，每行一条记录，各字段之间用英文的逗号(,)分隔" 
                style="margin-top: 5px; padding: 8px;" 
            />
        </a-col>
        <a-col style="text-align: right;">
            <a-button 
                v-if="header && content" 
                type="primary"
                :disabled="false" 
                @click="uploadText"  
                style="margin-top: 4px; float: right; position: absolute; top: 280px; right: 0px; z-index: 2;">
                上传数据
            </a-button>
            <a-button v-else 
                type="primary"
                :disabled="true" 
                @click="uploadText"  
                style="margin-top: 4px; float: right; position: absolute; top: 280px; right: 0px; z-index: 2;">
                上传数据
            </a-button>
        </a-col>
        <a-col :span="24" style="text-align: left; margin-top: 6px;">
            <a-upload 
                name="file" 
                accept=".csv" 
                :action="upload"
                :beforeUpload="getFileName" 
                @change="uploadFile"> 
                <a-tooltip placement="rightBottom">
                    <template slot="title">
                        <span>仅支持CSV格式的文件，第一行必须是字段的名称，第一个字段必须是客户主体名称</span>
                    </template>
                    <a-button style=""> <a-icon type="upload"/>点此按钮上传数据文件</a-button>
                </a-tooltip>
            </a-upload>
        </a-col>
    </a-row>
    <a-row v-for="(item, index) in uploadResults " :key="index" style="margin-top: 10px">
        <a-col :span="24">
            <a-row>
                <a-alert 
                    v-if="item.status === false"
                    type="error" 
                    message="文件上传失败！" 
                    style="text-align: left; font-weight: 500;"
                />
                <a-alert
                    v-if="item.status === true" 
                    type="success"
                    :message="item.uploadInfo"  
                    style="text-align: left; font-weight: 500;"
                />
            </a-row> 
            <a-row v-if="item.ignored && item.ignored.length > 0">
                <a-col style="text-align:left; font-weight: 800" :span="3">行号</a-col>
                <a-col style="text-align:left; font-weight: 800" :span="6">原因</a-col>
                <a-col style="text-align:left; font-weight: 800" :span="15">名称</a-col>
            </a-row> 
            <a-row v-for="(record, ir) in item.ignored" :key="ir">
                <a-col style="text-align:left;" :span="3"> {{record.lineno}} </a-col>
                <a-col style="text-align:left;" :span="6"> {{record.reason}} </a-col>
                <a-col style="text-align:left;" :span="15"> {{record.data}} </a-col>
            </a-row>
        </a-col>
    </a-row>
</a-row> 
</template>

<script>

import reqwest from 'reqwest'
import {BACKEND_API_PREFIX} from '@/util/config'

export default 
{
    name: 'upload',
    
    props: 
    {
        pfxtag: 
        {
            type: String,
            default: function() 
            {
                return "";
            }
        }
    },
    
    data() 
    {
        return {
            tab: "uc,upld",
            upload: BACKEND_API_PREFIX + "upload",
            tags: this.pfxtag,
            entType: "",
            types: [
                { "name": "客户", "value": "ent"},
                //{ "name": "商机", "value": "bidding"},
                //{ "name": "广告", "value": "news"}
            ],
            header: "",
            content: "",
            file: "",
            start: 0, 
            uploadResults : []
        }
    },
    
    components: 
    {
    },

    methods: 
    {
        getKey: function(key) 
        {
            this.entType = key;
        },

        getFileName: function(file) 
        {
            this.file = file; 
            this.startTime = (new Date()).valueOf(); 
        },

        uploadFile: function(info) 
        {
            if (info.file.status === 'uploading') 
            {
            }
            if (info.file.status === 'done') 
            {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('tags', this.tags);
                formData.append('ftype', "ent");
                formData.append('access_token', this.$store.getters.getToken());
                formData.append('agent_key', this.$store.getters.getAgentkey());
                let that = this;
                reqwest({
                    url: that.upload,
                    method: 'post',
                    processData: false,
                    data: formData,
                    success: (resp) => 
                    {
                        let rsp = JSON.parse(resp);
                        if (rsp.ret == 200)
                        {
                            let data = rsp.data;
                            that.uploadResults.unshift
                            ({
                                status : true, 
                                filename: this.file.name, 
                                uploadInfo: "文件 " + this.file.name + " 有" + data.total + "条记录，成功保存" + 
                                            data.saved + "条。" + "共耗时 " + 
                                            ((new Date()).valueOf() - this.startTime) + " 毫秒。" + 
                                            (data.total > data.saved ? "处理出错的记录如下表所示。" : "" ), 
                                ignored: data.ignored
                            });
                        } 
                        else
                        {
                            that.$message.error('上传失败！');
                        }
                    }, 
                    error: () => 
                    {
                        that.$message.error('上传失败！');
                    }
                });
            }
            if (info.file.status === 'error') 
            {
                this.uploadResults.push
                ({
                    status : false, 
                    filename: this.file
                }); 
            }
        },

        uploadText: function(info) 
        {
            this.startTime = (new Date()).valueOf();
            let headerLen = this.header.split(/[,，]/g).length;
            let contentRow = this.content.split("\n");
            for (let i = 0; i < contentRow.length; i++)
            {
                var rlen = contentRow[i].split(/[,，]/g).length; 
                if(rlen != headerLen)
                {
                  this.$message.info("第" + (i + 1) + "行中的字段数(" + rlen + 
                                     ")与标题行中的字段数(" + headerLen + 
                                     ")不相等，请检查数据");
                  return;
                }
            }

            //normalize the text as , separated 
            let newContent = "";
            for (let i = 0; i < contentRow.length; i++)
            {
                let tp = contentRow[i].split(/[,，]/g);
                newContent = newContent + (i ? "\n" : "") + tp; //by default use , to concatenate array elements 
            }

            //console.log(newContent)
            let text = this.header.split(/[,， ]/g) + "\n" + newContent;

            let textBlob = new Blob([text], {type : "text/plain"});
            const formData = new FormData();
            formData.append('file', textBlob);
            formData.append('tags', this.tags);
            formData.append('ftype', "ent");
            formData.append('access_token', this.$store.getters.getToken());
            formData.append('agent_key', this.$store.getters.getAgentkey());
            let that = this;
            reqwest
            ({
                url: that.upload,
                method: 'post',
                processData: false,
                data: formData,
                success: (resp) => 
                {
                    let rsp = JSON.parse(resp);
                    if (rsp.ret == 200){
                        let data = rsp.data;
                        //console.log(data);
                        that.uploadResults.unshift
                        ({
                            status : true, 
                            uploadInfo: "共上传" + data.total + "条记录，成功保存" + data.saved + "条。" + 
                                        "共耗时 " + ((new Date()).valueOf() - this.startTime) + " 毫秒。" + 
                                        (data.total > data.saved ? "处理出错的记录如下表所示。" : "" ), 
                            ignored: data.ignored
                        });
                    } 
                    else
                    {
                        that.$message.error('上传失败！');
                    }
                }, 
                error: () => 
                {
                    that.$message.error('上传失败！');
                }
            });
        }
    },
    
    created() 
    {
        this.$store.commit('changetab', this.tab)
    }
}
</script>

<style scoped>

  .line 
  {
      padding: 8px;
  }

  /deep/ .ant-tooltip-inner
  {
      background-color: crimson;
  }

</style>
